var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-dropdown-title"},[_c('r-icon',{attrs:{"name":_vm.icon,"size":24}}),_c('r-text',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('r-icon',{staticClass:"navbar-dropdown-arrow",attrs:{"name":"drop-down","size":24}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }